var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-container"},[_c('div',{staticClass:"error-content"},[_c('h1',{staticClass:"error-code"},[_vm._v("404")]),_c('h2',{staticClass:"error-message"},[_vm._v("¡Tu enlace ha caducado!")]),_c('p',{staticClass:"error-description"},[_vm._v("\n      Parece que este enlace ya no está disponible o ha expirado.  \n    ")])])])
}]

export { render, staticRenderFns }